<template>
  <div class="intercom-scene">
    <div class="header">
      <div class="title">方案场景描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in sceneList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import intercomscene1 from "../../../../assets/programme/intercomscene1.png";
import intercomscene2 from "../../../../assets/programme/intercomscene2.png";
import intercomscene3 from "../../../../assets/programme/intercomscene3.png";
import intercomscene4 from "../../../../assets/programme/intercomscene4.png";

export default {
  setup() {
    return reactive({
      sceneList: [
        {
          id: 1,
          title: "一键开启可视对讲",
          text: "业主可一键开启视频对讲，遇到问题随时联系物业解决，降低安全隐患",
          logo: intercomscene1,
        },
        {
          id: 2,
          title: "访客到访 可远程开门",
          text: "主人通过对讲设备与来访者进行双向可视通话，通过来访者的声音或图像确认来访者的身份",
          logo: intercomscene2,
        },
        {
          id: 3,
          title: "物业一键监管",
          text: "物业可线上远程监管数据，发现问题立即联系业主，降低人员线下作业成本，提高社区管理效率",
          logo: intercomscene3,
        },
        {
          id: 4,
          title: "广告投放  增加流量",
          text: "可通过可视对讲智能屏投放广告，增加社区流量，促进商业化进程",
          logo: intercomscene4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.intercom-scene {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.body .list .item {
  width: 570px;
  margin-bottom: 40px;
  text-align: center;
  border: 1px solid #D5E3FA;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 570px;
}
.body .list .item .title {
    font-size: 24px;
    color: #248EFB;
    margin-top: 40px;
}
.body .list .item .text {
    width: 260px;
    font-size: 14px;
    color: #495A6C;
    margin: 20px auto 40px;
}
</style>
